module.exports = __webpack_public_path__ + "img/atactks.8b39aa6.svg";